export default function KenoGameGem() {
  return (
    <svg
      width='68'
      height='80'
      viewBox='0 0 68 80'
      fill='none'
      preserveAspectRatio='xMidYMid meet'
      style={{
        width: '100%',
        height: '100%',
        transform: 'translate3d(0px, 0px, 0px)',
        contentVisibility: 'visible',
        filter: 'drop-shadow(0 0 40px var(--colors-primary))',
      }}
    >
      <g clipPath='url(#clip0_2453_2256)'>
        <path
          d='M21.4068 18.4553L8.81372 40L21.4068 61.5447H46.5931L59.1852 40L46.5931 18.4553H21.4068Z'
          fill='url(#paint0_radial_2453_2256)'
        />
        <path
          d='M21.4068 18.4553L8.81372 40L21.4068 61.5447H46.5931L59.1852 40L46.5931 18.4553H21.4068Z'
          fill='url(#paint1_radial_2453_2256)'
        />
        <path
          d='M8.81372 40L52.6759 28.8627L46.5931 18.4553H21.4068L8.81372 40Z'
          fill='url(#paint2_radial_2453_2256)'
        />
        <path
          d='M46.5932 18.4553H21.407L34.0001 0L46.5932 18.4553Z'
          fill='url(#paint3_linear_2453_2256)'
        />
        <path
          d='M68 19.4685L46.5931 18.4553L34 0L68 19.4685Z'
          fill='url(#paint4_linear_2453_2256)'
        />
        <path
          d='M59.1851 40L46.593 18.4553L67.9999 19.4685L59.1851 40Z'
          fill='url(#paint5_linear_2453_2256)'
        />
        <path
          d='M68.0001 19.4685V60.5315L59.1853 40L68.0001 19.4685Z'
          fill='url(#paint6_linear_2453_2256)'
        />
        <path
          d='M59.1851 40L46.593 61.5447L67.9999 60.5315L59.1851 40Z'
          fill='url(#paint7_linear_2453_2256)'
        />
        <path
          d='M34 0L21.4069 18.4553L0 19.4685L34 0Z'
          fill='url(#paint8_linear_2453_2256)'
        />
        <path
          d='M21.4069 18.4553L8.81375 40L0 19.4685L21.4069 18.4553Z'
          fill='url(#paint9_linear_2453_2256)'
        />
        <path
          d='M9.40579 19.0228L0 19.4685L2.80704 26.0068L9.40579 19.0228Z'
          fill='url(#paint10_linear_2453_2256)'
        />
        <path
          d='M13.5244 18.8279L4.14429 29.1225L6.17428 33.8506L17.2996 18.6492L13.5244 18.8279Z'
          fill='url(#paint11_linear_2453_2256)'
        />
        <path
          d='M0 19.4685L8.81375 40L0 60.5315V19.4685Z'
          fill='url(#paint12_linear_2453_2256)'
        />
        <path
          d='M8.81375 40L21.4069 61.5447L0 60.5315L8.81375 40Z'
          fill='url(#paint13_linear_2453_2256)'
        />
        <path
          d='M46.5932 61.5447L34.0001 80L21.407 61.5447H46.5932Z'
          fill='url(#paint14_linear_2453_2256)'
        />
        <path
          d='M46.5931 61.5447L68 60.5315L34 80L46.5931 61.5447Z'
          fill='url(#paint15_linear_2453_2256)'
        />
        <path
          d='M21.4069 61.5447L34 80L0 60.5315L21.4069 61.5447Z'
          fill='url(#paint16_linear_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d='M21.407 61.5447H46.5932L34.0001 40L21.407 61.5447Z'
          fill='url(#paint17_linear_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d='M46.5932 18.4553H21.407L34.0001 40L46.5932 18.4553Z'
          fill='url(#paint18_linear_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d='M34 40L46.5931 61.5447L59.1852 40H34Z'
          fill='url(#paint19_linear_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d='M8.81372 40L21.4068 61.5447L34 40H8.81372Z'
          fill='url(#paint20_linear_2453_2256)'
        />
        <path
          d='M32.3751 18.4553L34.0001 0L21.407 18.4553H32.3751Z'
          fill='url(#paint21_linear_2453_2256)'
        />
        <path
          d='M20.9495 7.47227L21.4069 18.4553L34 0L20.9495 7.47227Z'
          fill='url(#paint22_linear_2453_2256)'
        />
        <path
          d='M46.593 18.4553L67.9999 19.4685L53.8455 11.3638L46.593 18.4553Z'
          fill='url(#paint23_linear_2453_2256)'
        />
        <path
          d='M29.2153 61.5447C31.0685 69.0169 33.9999 80 33.9999 80L46.5931 61.5447H29.2153Z'
          fill='url(#paint24_linear_2453_2256)'
        />
        <path
          d='M21.4068 61.5447L33.9999 80L10.3708 66.4697L21.4068 61.5447Z'
          fill='url(#paint25_linear_2453_2256)'
        />
        <path
          d='M40.2965 61.4117L34 61.3366C31.9011 61.3041 29.8022 61.3112 27.7034 61.298L21.5641 61.2747L18.4734 56.0349C17.4137 54.246 16.3694 52.447 15.2912 50.6683L12.0771 45.3199C10.9886 43.5473 9.91657 41.7645 8.8137 40C9.80968 41.8254 10.8365 43.6346 11.8469 45.4519L14.9294 50.8754C15.95 52.6866 17.0046 54.4796 18.0437 56.2806L20.9258 61.2554L16.0682 61.0472L13.3917 60.9325C12.4995 60.8909 11.6074 60.8655 10.7142 60.834L5.35912 60.6553C3.57273 60.6137 1.78839 60.5559 0.000976562 60.5305C1.78223 60.6736 3.56451 60.7843 5.34679 60.9122L10.6946 61.2401C11.5858 61.2929 12.4769 61.3528 13.3691 61.3955L16.0446 61.5335L21.2434 61.8026L21.2496 61.8138H21.266C21.7594 62.5447 22.2651 63.2676 22.7636 63.9955L24.3485 66.2951C25.4092 67.8251 26.4525 69.3672 27.5276 70.8891L30.7396 75.4608C31.8281 76.9735 32.8991 78.4964 34.002 79.999C33.005 78.4264 31.9782 76.873 30.9678 75.3095L27.8833 70.6536C26.8595 69.0982 25.8039 67.5652 24.7658 66.02L23.2025 63.7062C22.7739 63.0757 22.3494 62.4422 21.9187 61.8127L27.7054 61.7904C29.8043 61.7772 31.9032 61.7853 34.002 61.7518L40.2986 61.6767C42.3974 61.632 44.4963 61.6056 46.5951 61.5437C44.4963 61.4828 42.3974 61.4564 40.2986 61.4117H40.2965Z'
          fill='url(#paint26_linear_2453_2256)'
        />
        <path
          d='M63.7869 50.184C63.0828 48.4601 62.3418 46.7524 61.6192 45.0367L59.4916 40.0193L59.5029 40L59.4916 39.9807L61.6192 34.9633C62.3428 33.2475 63.0828 31.5389 63.7869 29.815L65.9207 24.6524C66.6135 22.9244 67.3237 21.2026 68.0011 19.4685C67.2096 21.1559 66.4511 22.8564 65.6751 24.5499L63.4015 29.6535C62.6368 31.3521 61.908 33.0648 61.1618 34.7714L59.1503 39.401L56.2549 34.4912C55.1952 32.7023 54.1509 30.9033 53.0727 29.1246L49.8586 23.7762C48.7701 22.0036 47.6981 20.2208 46.5952 18.4563C47.5912 20.2817 48.618 22.0909 49.6284 23.9082L52.7109 29.3317C53.7315 31.1429 54.7861 32.9359 55.8252 34.7369L58.8738 40L55.8252 45.2631C54.7871 47.0651 53.7305 48.8561 52.7109 50.6683L49.6284 56.0918C48.618 57.9091 47.5922 59.7183 46.5962 61.5437C47.6991 59.7792 48.7722 57.9964 49.8607 56.2238L53.0747 50.8754C54.1529 49.0967 55.1952 47.2976 56.2559 45.5088L59.1513 40.599L61.1628 45.2286C61.909 46.9342 62.6368 48.6489 63.4015 50.3464L65.6751 55.4501C66.4511 57.1436 67.2106 58.8441 68.0021 60.5315C67.3247 58.7964 66.6145 57.0756 65.9217 55.3466L63.789 50.184H63.7869Z'
          fill='url(#paint27_linear_2453_2256)'
        />
        <path
          d='M54.6092 19.0675C55.5014 19.1091 56.3936 19.1355 57.2868 19.166L62.6418 19.3447C64.4282 19.3853 66.2125 19.4441 68 19.4685C66.2187 19.3243 64.4364 19.2137 62.6542 19.0858L57.3063 18.7578C56.4151 18.704 55.524 18.6462 54.6318 18.6035L51.9564 18.4644L46.8942 18.1934C46.7935 18.1883 46.702 18.1365 46.6455 18.0543L45.2363 16.0024L43.6514 13.7029C42.5907 12.1729 41.5484 10.6297 40.4723 9.10988L37.2603 4.53819C36.1728 3.02546 35.1008 1.50258 33.9989 0C34.9959 1.57263 36.0228 3.12597 37.0342 4.68946L40.1187 9.34542C41.1414 10.9008 42.198 12.4338 43.2362 13.9801L44.7995 16.2938L46.0391 18.1223C46.0586 18.1507 46.0381 18.1883 46.0031 18.1883L40.2945 18.2106C38.1956 18.2228 36.0968 18.2167 33.9979 18.2492L27.7013 18.3243C25.6025 18.369 23.5036 18.3954 21.4048 18.4563C23.5036 18.5172 25.6025 18.5436 27.7013 18.5883L33.9979 18.6634C36.0968 18.6959 38.1956 18.6898 40.2945 18.702L46.259 18.7253C46.367 18.7253 46.4667 18.7822 46.5211 18.8746L49.5235 23.9651C50.5842 25.754 51.6264 27.553 52.7046 29.3317L55.9187 34.6801C57.0072 36.4527 58.0803 38.2355 59.1831 40C58.1872 38.1736 57.1614 36.3654 56.151 34.5481L53.0685 29.1246C52.0478 27.3124 50.9923 25.5215 49.9541 23.7194L47.1111 18.8116C47.0947 18.7822 47.1163 18.7467 47.1502 18.7487L51.9296 18.9538L54.6062 19.0685L54.6092 19.0675Z'
          fill='url(#paint28_linear_2453_2256)'
        />
        <path
          d='M15.2921 50.6683C14.2715 48.8561 13.2159 47.0651 12.1778 45.2631L9.70376 40.9919C9.34812 40.3777 9.34812 39.6223 9.70376 39.0081L12.1778 34.7369C13.2169 32.9359 14.2715 31.1429 15.2921 29.3317L18.3746 23.9082C19.385 22.0909 20.4118 20.2817 21.4078 18.4563C20.3049 20.2208 19.2329 22.0036 18.1444 23.7762L14.9303 29.1246C13.8521 30.9033 12.8078 32.7023 11.7481 34.4912L8.92054 39.2853C8.89279 39.333 8.82084 39.3289 8.79926 39.2781L6.84122 34.7714C6.095 33.0648 5.36626 31.3521 4.60155 29.6535L2.32796 24.5499C1.55194 22.8564 0.793392 21.1559 0.00195312 19.4685C0.679301 21.2036 1.38954 22.9244 2.08231 24.6524L4.21611 29.815C4.92018 31.5389 5.66023 33.2475 6.38383 34.9633L8.16713 39.1685C8.38709 39.6883 8.38812 40.2731 8.16919 40.7929L6.3828 45.0367C5.66023 46.7524 4.91915 48.4611 4.21508 50.184L2.08231 55.3466C1.38954 57.0756 0.679301 58.7964 0.00195312 60.5315C0.793392 58.8441 1.55297 57.1436 2.32899 55.4501L4.60258 50.3464C5.36729 48.6479 6.095 46.9342 6.84122 45.2286L8.79926 40.7218C8.82187 40.6711 8.89279 40.667 8.92054 40.7147L11.7481 45.5088C12.8089 47.2976 13.8511 49.0967 14.9293 50.8754L18.1434 56.2238C19.2319 57.9964 20.3049 59.7792 21.4078 61.5437C20.4118 59.7172 19.386 57.9091 18.3757 56.0918L15.2932 50.6683H15.2921Z'
          fill='url(#paint29_linear_2453_2256)'
        />
        <path
          d='M43.4448 18.3487L40.2966 18.2583L37.1483 18.1913L34 18.1406C31.9011 18.103 29.8023 18.0949 27.7034 18.0725L22.6197 18.0543C22.4275 18.0543 22.3145 17.8421 22.4214 17.6847L24.881 14.0582C25.9109 12.5069 26.9541 10.9647 27.9727 9.40735C28.9985 7.85401 30.013 6.29255 31.0223 4.72804L32.5179 2.36859C33.0194 1.5838 33.5128 0.794944 34 0C33.4378 0.743166 32.8817 1.49242 32.3339 2.24574L30.6811 4.50062C29.5916 6.01234 28.5062 7.52608 27.4341 9.04896C26.3549 10.5668 25.2983 12.1008 24.2293 13.6257L21.5436 17.5385C21.3164 17.8695 20.9454 18.0766 20.5404 18.0969L18.7108 18.1893L16.0354 18.3314L13.3609 18.4858L10.6875 18.6523L8.01409 18.8299L5.3417 19.0228L2.67033 19.2381C1.7792 19.3061 0.889084 19.3853 0 19.4695C0.894223 19.4695 1.78742 19.4634 2.68061 19.4472L5.36123 19.4086L8.04081 19.3487L10.7194 19.2726L13.3969 19.1863L16.0744 19.0878L18.7509 18.9771L20.2464 18.9111C20.4356 18.903 20.5599 19.104 20.4654 19.2665L17.9225 23.6514C16.8926 25.4585 15.8493 27.2565 14.8338 29.0708L13.3044 31.7896L11.7894 34.5166L10.2949 37.2558C9.79328 38.1665 9.30095 39.0832 8.81478 40.002C9.37803 39.1259 9.93513 38.2467 10.483 37.3624L12.1368 34.7146L13.77 32.0546L15.3889 29.3865C16.4712 27.6098 17.5268 25.8179 18.5968 24.0341L21.3688 19.3284C21.5395 19.038 21.853 18.8594 22.1932 18.8583L27.7045 18.8391C29.8033 18.8167 31.9022 18.8086 34.001 18.771L37.1493 18.7203L40.2976 18.6533L43.4459 18.5629C44.4953 18.5365 45.5447 18.5 46.5942 18.4563C45.5447 18.4127 44.4953 18.3761 43.4459 18.3497L43.4448 18.3487Z'
          fill='url(#paint30_radial_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d='M21.1001 24.5583C23.9298 24.326 26.0331 21.8719 25.798 19.0769C25.5628 16.2818 23.0783 14.2043 20.2486 14.4365C17.4189 14.6688 15.3156 17.1229 15.5507 19.9179C15.7859 22.713 18.2704 24.7905 21.1001 24.5583Z'
          fill='url(#paint31_radial_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d='M20.7666 20.9619C20.894 20.4056 21.411 20.0218 21.9877 20.0553L27.6305 20.3853L22.1161 19.1538C21.5529 19.0279 21.1644 18.5172 21.1983 17.9476L21.5323 12.3739L20.2856 17.8207C20.1581 18.3771 19.6411 18.7609 19.0645 18.7274L13.4216 18.3974L18.936 19.6289C19.4993 19.7548 19.8878 20.2655 19.8539 20.835L19.5198 26.4088L20.7666 20.9619Z'
          fill='url(#paint32_radial_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d='M11.0073 40.6792C11.2838 39.5259 10.5612 38.3695 9.39253 38.0964C8.2249 37.8233 7.05418 38.5371 6.7777 39.6914C6.50121 40.8447 7.22378 42.0011 8.39244 42.2742C9.56006 42.5473 10.7308 41.8336 11.0073 40.6792Z'
          fill='url(#paint33_radial_2453_2256)'
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d='M21.8406 61.697C21.9054 61.4249 21.7358 61.1528 21.4603 61.0878C21.1849 61.0239 20.9094 61.1914 20.8436 61.4635C20.7789 61.7356 20.9485 62.0077 21.2239 62.0726C21.4994 62.1366 21.7748 61.9691 21.8406 61.697Z'
          fill='url(#paint34_radial_2453_2256)'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(45.5231 58.6492) rotate(180) scale(36.9931 36.54)'
        >
          <stop stopColor='#CE1EFA' />
          <stop offset='1' stopColor='#FF47CB' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(45.5231 58.6492) rotate(180) scale(36.9931 36.54)'
        >
          <stop stopColor='#CE1EFA' />
          <stop offset='1' stopColor='#FF47CB' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(20.71 38.5523) scale(32.1437 31.75)'
        >
          <stop stopColor='#CE1EFA' />
          <stop offset='1' stopColor='#FF47CB' />
        </radialGradient>
        <linearGradient
          id='paint3_linear_2453_2256'
          x1='34.0001'
          y1='18.4634'
          x2='32.933'
          y2='0.175107'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EA7EF4' />
          <stop offset='1' stopColor='#F46BE1' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_2453_2256'
          x1='46.2467'
          y1='18.2959'
          x2='50.8102'
          y2='9.8706'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D63AC1' />
          <stop offset='0.49' stopColor='#DF31BA' />
          <stop offset='1' stopColor='#EF24B1' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_2453_2256'
          x1='67.6463'
          y1='19.3234'
          x2='53.5291'
          y2='29.0336'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F403B8' />
          <stop offset='0.24' stopColor='#F407B8' />
          <stop offset='0.5' stopColor='#F714B8' />
          <stop offset='0.77' stopColor='#FA29B8' />
          <stop offset='1' stopColor='#FF42B8' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_2453_2256'
          x1='59.1853'
          y1='40'
          x2='68.0001'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C7159A' />
          <stop offset='0.38' stopColor='#C21198' />
          <stop offset='0.77' stopColor='#B60995' />
          <stop offset='1' stopColor='#AB0193' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_2453_2256'
          x1='52.8783'
          y1='50.7658'
          x2='68.019'
          y2='59.3935'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D902CA' />
          <stop offset='0.07' stopColor='#D904CC' />
          <stop offset='0.61' stopColor='#DC12DE' />
          <stop offset='1' stopColor='#DE18E5' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_2453_2256'
          x1='16.7703'
          y1='9.43171'
          x2='22.6957'
          y2='17.4299'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D63AC1' />
          <stop offset='0.25' stopColor='#DC42CA' />
          <stop offset='0.66' stopColor='#EC58E4' />
          <stop offset='1' stopColor='#FE70FF' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_2453_2256'
          x1='14.7516'
          y1='29.0383'
          x2='-0.395374'
          y2='20.8659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D1B9E1' />
          <stop offset='0.22' stopColor='#D6AFE4' />
          <stop offset='0.58' stopColor='#E695EF' />
          <stop offset='1' stopColor='#FE70FF' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_2453_2256'
          x1='10.9404'
          y1='26.2575'
          x2='-2.43031'
          y2='15.6475'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D1B9E1' />
          <stop offset='0.22' stopColor='#D6AFE4' />
          <stop offset='0.58' stopColor='#E695EF' />
          <stop offset='1' stopColor='#FE70FF' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_2453_2256'
          x1='15.5009'
          y1='29.5662'
          x2='4.60495'
          y2='19.728'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D1B9E1' />
          <stop offset='0.22' stopColor='#D6AFE4' />
          <stop offset='0.58' stopColor='#E695EF' />
          <stop offset='1' stopColor='#FE70FF' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_2453_2256'
          x1='0'
          y1='40'
          x2='8.81375'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F03EBB' />
          <stop offset='0.08' stopColor='#F042BE' />
          <stop offset='0.66' stopColor='#F05ED2' />
          <stop offset='1' stopColor='#F069DA' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_2453_2256'
          x1='14.2428'
          y1='51.1505'
          x2='0.255312'
          y2='57.4029'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF21B5' />
          <stop offset='0.45' stopColor='#F726B1' />
          <stop offset='1' stopColor='#E731AA' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_2453_2256'
          x1='33.9929'
          y1='61.7508'
          x2='33.4594'
          y2='78.6877'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D10FC2' />
          <stop offset='0.29' stopColor='#E117D2' />
          <stop offset='0.7' stopColor='#F321E3' />
          <stop offset='1' stopColor='#FA25EA' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_2453_2256'
          x1='34'
          y1='70.2658'
          x2='68'
          y2='70.2658'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#94018B' />
          <stop offset='0.25' stopColor='#A10197' />
          <stop offset='0.69' stopColor='#B301A8' />
          <stop offset='1' stopColor='#BA02AF' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_2453_2256'
          x1='0'
          y1='70.2658'
          x2='34'
          y2='70.2658'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C71A87' />
          <stop offset='0.21' stopColor='#BF1A83' />
          <stop offset='0.54' stopColor='#A91A79' />
          <stop offset='0.94' stopColor='#861A69' />
          <stop offset='1' stopColor='#801B67' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_2453_2256'
          x1='38.9111'
          y1='41.7848'
          x2='34.0106'
          y2='61.992'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.27' stopColor='#FFFBFE' />
          <stop offset='0.49' stopColor='#FFF1FB' />
          <stop offset='0.7' stopColor='#FFDFF6' />
          <stop offset='0.9' stopColor='#FFC7EF' />
          <stop offset='1' stopColor='#FFB9EB' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_2453_2256'
          x1='34.0001'
          y1='39.731'
          x2='34.0001'
          y2='18.9213'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.27' stopColor='#FFFBFE' />
          <stop offset='0.49' stopColor='#FFF1FB' />
          <stop offset='0.7' stopColor='#FFDFF6' />
          <stop offset='0.9' stopColor='#FFC7EF' />
          <stop offset='1' stopColor='#FFB9EB' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_2453_2256'
          x1='52.7581'
          y1='50.6774'
          x2='30.0636'
          y2='33.9255'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.27' stopColor='#FFFBFE' />
          <stop offset='0.49' stopColor='#FFF1FB' />
          <stop offset='0.7' stopColor='#FFDFF6' />
          <stop offset='0.9' stopColor='#FFC7EF' />
          <stop offset='1' stopColor='#FFB9EB' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_2453_2256'
          x1='33.4593'
          y1='39.6254'
          x2='15.3433'
          y2='50.9051'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.41' stopColor='#FFFCFE' />
          <stop offset='0.6' stopColor='#FFF5FC' />
          <stop offset='0.75' stopColor='#FFE8F8' />
          <stop offset='0.87' stopColor='#FFD6F3' />
          <stop offset='0.98' stopColor='#FFBEEC' />
          <stop offset='1' stopColor='#FFB9EB' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_2453_2256'
          x1='27.5453'
          y1='13.8775'
          x2='29.6813'
          y2='-1.44488'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EA7EF4' />
          <stop offset='1' stopColor='#F46BE1' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_2453_2256'
          x1='25.3034'
          y1='6.06716'
          x2='29.8226'
          y2='12.1665'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D63AC1' />
          <stop offset='0.25' stopColor='#DC42CA' />
          <stop offset='0.66' stopColor='#EC58E4' />
          <stop offset='1' stopColor='#FE70FF' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_2453_2256'
          x1='48.215'
          y1='19.2624'
          x2='59.5001'
          y2='15.7611'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D63AC1' />
          <stop offset='0.49' stopColor='#DF31BA' />
          <stop offset='1' stopColor='#EF24B1' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_2453_2256'
          x1='38.0229'
          y1='58.1578'
          x2='37.3109'
          y2='78.8777'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D10FC2' />
          <stop offset='0.29' stopColor='#E117D2' />
          <stop offset='0.7' stopColor='#F321E3' />
          <stop offset='1' stopColor='#FA25EA' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_2453_2256'
          x1='22.0204'
          y1='73.6262'
          x2='26.486'
          y2='62.7767'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C71A87' />
          <stop offset='0.2' stopColor='#BF1783' />
          <stop offset='0.51' stopColor='#A91178' />
          <stop offset='0.88' stopColor='#860767' />
          <stop offset='1' stopColor='#7A0462' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_2453_2256'
          x1='25.622'
          y1='64.1123'
          x2='39.7739'
          y2='83.2871'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F060D8' />
          <stop offset='1' stopColor='#F01FCC' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_2453_2256'
          x1='57.2467'
          y1='40.2518'
          x2='61.9179'
          y2='64.96'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F060D8' />
          <stop offset='1' stopColor='#F01FCC' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_2453_2256'
          x1='61.6746'
          y1='32.0648'
          x2='46.1571'
          y2='19.7855'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F060D8' />
          <stop offset='1' stopColor='#F0AEE5' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_2453_2256'
          x1='12.371'
          y1='60.0147'
          x2='10.7432'
          y2='39.4892'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F060D8' />
          <stop offset='1' stopColor='#F0AEE5' />
        </linearGradient>
        <radialGradient
          id='paint30_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(21.3812 18.3132) scale(25.3651 25.0544)'
        >
          <stop stopColor='white' />
          <stop offset='0.43' stopColor='#F7D4F1' />
          <stop offset='0.79' stopColor='#F1B8E8' />
          <stop offset='1' stopColor='#F0AEE5' />
        </radialGradient>
        <radialGradient
          id='paint31_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(20.6467 19.4967) rotate(44.647) scale(5.10988 5.10949)'
        >
          <stop stopColor='white' />
          <stop offset='0.22' stopColor='#B3B3B3' />
          <stop offset='0.43' stopColor='#737373' />
          <stop offset='0.61' stopColor='#414141' />
          <stop offset='0.78' stopColor='#1D1D1D' />
          <stop offset='0.91' stopColor='#070707' />
          <stop offset='0.99' />
        </radialGradient>
        <radialGradient
          id='paint32_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(20.5258 19.3941) rotate(44.647) scale(5.70035 5.69991)'
        >
          <stop stopColor='white' />
          <stop offset='0.09' stopColor='#F1F1F1' />
          <stop offset='0.26' stopColor='#CDCDCD' />
          <stop offset='0.49' stopColor='#929292' />
          <stop offset='0.78' stopColor='#424242' />
          <stop offset='0.99' />
        </radialGradient>
        <radialGradient
          id='paint33_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(8.8928 40.1887) rotate(44.647) scale(2.15959 2.15943)'
        >
          <stop stopColor='white' />
          <stop offset='0.22' stopColor='#B3B3B3' />
          <stop offset='0.43' stopColor='#737373' />
          <stop offset='0.61' stopColor='#414141' />
          <stop offset='0.78' stopColor='#1D1D1D' />
          <stop offset='0.91' stopColor='#070707' />
          <stop offset='0.99' />
        </radialGradient>
        <radialGradient
          id='paint34_radial_2453_2256'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(21.342 61.584) rotate(44.647) scale(0.509763 0.509724)'
        >
          <stop stopColor='white' />
          <stop offset='0.22' stopColor='#CBCBCB' />
          <stop offset='0.72' stopColor='#4A4A4A' />
          <stop offset='0.99' />
        </radialGradient>
        <clipPath id='clip0_2453_2256'>
          <rect width='68' height='80' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
